import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Tooltip } from "@mui/material";

interface DropdownOptionInfoLinkProps {
	href: string;
	label?: string;
}

const DropdownOptionInfoLink = ({ href, label = "View course details on public catalog" }: DropdownOptionInfoLinkProps) => (
	<Tooltip title={label} placement="left" arrow>
		<IconButton
			component="a"
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			size="small"
			aria-label={label}
			onMouseDown={event => event.stopPropagation()}
			onClick={event => event.stopPropagation()}
			sx={{
				ml: "auto",
				flexShrink: 0,
				color: "primary.main",
				p: 0.5,
				"&:hover": { bgcolor: "rgba(46, 125, 50, 0.08)" },
			}}
		>
			<InfoOutlinedIcon sx={{ fontSize: 18 }} />
		</IconButton>
	</Tooltip>
);

export default DropdownOptionInfoLink;
